export function getHostname(host = '') {
  return host.replace(/:[0-9]+/, '');
}
